// https://dev.azure.com/toolfactory/Marketing/_git/alexandria-components-marketing?path=/components/product-card-hotels/index.js
export const checkDetails = (details)=>{
    if (details.length > 200) return {
        content: `${details?.slice(0, 200)}...`
    };
    return {
        content: details
    };
};
export const productCardHotelsDesktopConverter = (props)=>{
    const data = props.props ?? props.data ?? {};
    const { title ='' , subtitle ='' , summary , itinerary , link ={
        href: ''
    } , image ={
        src: ''
    } , config , price , stars , star , reviews , descriptions =[] , rating , icon =''  } = data;
    const ratingStars = typeof stars === 'number' ? stars : stars?.value;
    const ratingStar = typeof star === 'number' ? star : star?.value;
    const moreInfo = itinerary?.details ? [
        checkDetails(itinerary.details)
    ] : undefined;
    const _descriptions = summary?.details ? summary.details.map((x)=>x.content ?? '') : descriptions?.flatMap((x)=>x.content);
    return {
        ...data,
        config: {
            ...config,
            deal: config?.deal,
            icon: !!config?.icon || !!icon,
            iconName: config?.icon ?? icon,
            soldOut: props.soldOut,
            zone: true,
            literals: {
                fromCaption: price?.from,
                priceCaption: price?.caption,
                summary: summary?.tab_name,
                moreInfo: itinerary?.tab_name,
                excelent: reviews?.content ?? rating?.content,
                good: reviews?.content ?? rating?.content,
                veryGood: reviews?.content ?? rating?.content
            }
        },
        image,
        link,
        price: {
            value: price?.value,
            from: !!price?.from,
            caption: !!price?.caption
        },
        title: summary?.title ?? title,
        subtitle: summary?.subtitle ?? subtitle,
        rating: ratingStars ?? ratingStar,
        descriptions: _descriptions,
        moreInfo,
        reviews: reviews?.number ?? rating?.number
    };
};

//# sourceMappingURL=converter.js.map